import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { pluralise, timeInMins } from '~/utils/formatStrings';
import TFormatTags from '~/components/atoms/t-format-tags.vue';
import TTag from '~/components/atoms/t-tag.vue';
import { CardData } from '~/composables/useCardData';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceTags',
  props: {
    resource: null,
    readingTime: null
  },
  setup(__props: any) {

const props = __props as {
  resource: CardData;
  readingTime?: string;
};



const isTeachingResource = computed(() => props.resource?.postType === 'teaching-resource');

const resourceDuration = computed(() => {
  if (props.resource?.duration) {
    if (props.resource.postType === 'video') {
      return `${props.resource.duration + ' ' + pluralise('min', props.resource.duration)}`;
    }
    return pluralise(timeInMins(props.resource.duration, true), props.resource.duration);
  }
  return '';
});
const isDifferentiated = computed(() => {
  if (props.resource?.tags) {
    return Object.values(props.resource.tags).some(v => v.slug === 'differentiated');
  }
  return false;
});

return { __sfc: true,props, isTeachingResource, resourceDuration, isDifferentiated, TFormatTags, TTag }
}

})